module.exports = __webpack_public_path__ + "static/media/Ga.4ac28962.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Ga.mp3
// module id = 46
// module chunks = 0